import React, { Fragment } from 'react';

const InputField = ({
  formValues,
  name,
  label,
  type,
  handleChange,
  placeholder,
  required,
  renderComponent,
  handleBlur,
  noError,
  isDisabled,
}) => {
  const inputFieldData = formValues[name];
  const { value, hasError } = inputFieldData;
  const isEmpty = !value;
  const errorText = isEmpty ? `${label} is required` : `${label} is invalid`;

  if (renderComponent) {
    return renderComponent({
      value,
      handleSelectChange: handleChange,
      handleFocusOutCategory: handleBlur,
    });
  }

  if (type == 'textarea') {
    return (
      <Fragment>
        <label for={name}>{label}</label>
        <textarea
          id={name}
          type={type}
          className="form-control py-3 pl-4 pr-4"
          placeholder={placeholder}
          name={name}
          value={value}
          onChange={handleChange}
          onBlur={handleChange}
          required={required}
          disabled={isDisabled}
        />
        <div className="row error">
          {hasError && (value || required) && errorText}
        </div>
      </Fragment>
    );
  }
  return (
    <Fragment>
      <label for={name}>{label}</label>
      <input
        id={name}
        type={type}
        className="form-control py-3 pl-4 pr-4"
        placeholder={placeholder}
        name={name}
        value={value}
        onChange={handleChange}
        onBlur={handleChange}
        required={required}
        disabled={isDisabled}
      />
      {!noError && (
        <div className="row error">
          {hasError && (value || required) && errorText}
        </div>
      )}
    </Fragment>
  );
};

export default InputField;



// WEBPACK FOOTER //
// ./src/components/transactions/InputField.js